import { EditorConfigContext, MediaLibrary } from "@prismicio/editor-fields"
import { Box } from "@prismicio/editor-ui"
import { useState } from "react"

import { staticEditorConfig } from "../app/editorConfig"
import { useHeaderOffset } from "../app/layout/useOffset"
import { routeAnimationDuration, useRepositoryMetaTitle } from "../app/routing"
import { mainContentMaxWidth } from "../document/documentLayout"
import { MediaLibraryPageHeader } from "./MediaLibraryPageHeader"

// Since this is a page outside of the document editor
// we need to exclude specific document fields from the config
// to get a correctly typed `EditorConfig` object.
const { searchDocuments, uidField, ...simpleConfig } = staticEditorConfig

export function MediaLibraryPage() {
  const [actionContainer, setActionContainer] = useState<Element | null>(null)
  const { headerOffset } = useHeaderOffset()

  useRepositoryMetaTitle("Media Library")

  return (
    <Box
      position="fixed"
      top={headerOffset}
      flexDirection="column"
      animation={{ name: "fadeIn", duration: routeAnimationDuration }}
      maxHeight={`calc(100vh - ${headerOffset}px)`}
      width="100%"
      backgroundColor="grey2"
    >
      <MediaLibraryPageHeader ref={setActionContainer} />
      <Box
        justifyContent="center"
        overflow="hidden"
        padding={{ top: 16, right: 16, left: 16 }}
        height="100vh"
      >
        <Box maxWidth={mainContentMaxWidth} width="100%">
          <EditorConfigContext.Provider value={simpleConfig}>
            <MediaLibrary actionContainer={actionContainer} />
          </EditorConfigContext.Provider>
        </Box>
      </Box>
    </Box>
  )
}
